import { gql, useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import Button from "../../../Button/Button";
import { MultiSelectionComponent } from "../../../MultiSelectionComponent/MultiSelectionComponent";
import PortalFooter from "../../../Reactportal/PortalFooter";
import Reactportal from "../../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../../ToastComponent/RectHotToast";
import ".././AddVendorAccount.scss";

export const GET_VEHICLE_CATEGORY_OF_USER = gql`
  query GetAllVehicleCategoryManagement($AccountID: ID) {
    getAllVehicleCategoryManagement(AccountID: $AccountID) {
      _id
      Unique_Id
      VehicleCategoryGroupData {
        _id
        VehicleType
        VehicleCategory {
          _id
          Unique_Id
          Name
          User_ID
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_VEHICLE_TYPE = gql`
  query SearchVehicleTypeMasters($keyword: String) {
    searchVehicleTypeMasters(keyword: $keyword) {
      _id

      Search_Value
    }
  }
`;

export const GET_VEHICLE_CATEGORY = gql`
  query SearchVehicleCategory_With_VechileMasters($keyword: String!, $vehicleTypeId: ID) {
    searchVehicleCategory_With_VechileMasters(keyword: $keyword, Vehicle_Type_Id: $vehicleTypeId) {
      _id
      Unique_Id
      Name
      Search_Value
      Vehicle_Type
      User_ID
      createdAt
      updatedAt
    }
  }
`;

const CREATE_VEHICLE_CATEGORY = gql`
  mutation CreateVehicleCategoryManagement($createInput: VehicleCategoryManagementInput, $AccountId: ID) {
    createVehicleCategoryManagement(createInput: $createInput, AccountId: $AccountId) {
      _id
    }
  }
`;

const VehicleCategorySelection = ({ show, setShowModal, vehicleIds, setPreferedVehicle, allFieldsData }) => {
  const [open, setOpen] = useState(show);

  const { data: SelectedVehicleCategory } = useQuery(GET_VEHICLE_CATEGORY_OF_USER, {
    variables: { AccountID: allFieldsData?._id },
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [CreateVehicleCategory] = useMutation(CREATE_VEHICLE_CATEGORY, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [openMultiSelect, setMultiselectModal] = useState(false);

  const [selectedVehicleTypes, setSelectedVehicleTypes] = useState(vehicleIds ? vehicleIds : []);
  const [TempselectedVehicleTypes, setTempSelectedVehicleTypes] = useState(vehicleIds ? vehicleIds : []);
  const [tempCategory, setTempCategory] = useState({});
  const [selectedVehicleTypesWithCategories, setSelectedVehicleTypesWithCategories] = useState({});
  useEffect(() => {
    let vehicledata = SelectedVehicleCategory?.getAllVehicleCategoryManagement[0]?.VehicleCategoryGroupData;
    let UpdatedData = vehicledata?.reduce((acc, { VehicleType, VehicleCategory }) => {
      acc[VehicleType] = VehicleCategory;
      return acc;
    }, {});
    setSelectedVehicleTypesWithCategories(UpdatedData);
    setTempCategory(UpdatedData);
  }, [SelectedVehicleCategory]);
  const Closeformfunction2 = () => {
    setShowModal();
    setPreferedVehicle(selectedVehicleTypes);

    setOpen(false);
  };

  const handleVehicleTypeCheckboxChange = (vehicleType, category, check) => {
    let type = tempCategory && tempCategory[vehicleType?.Search_Value];
    let updatedData = type?.filter((el) => el._id !== category._id) || [];
    if (check) {
      updatedData.push(category);
    }
    setTempCategory((prev) => {
      return { ...prev, [vehicleType.Search_Value]: updatedData };
    });
    if (TempselectedVehicleTypes.includes(category?._id)) {
      setTempSelectedVehicleTypes((prevSelected) => prevSelected.filter((id) => id !== category?._id));
    } else {
      setTempSelectedVehicleTypes((prevSelected) => [...prevSelected, category?._id]);
    }
  };

  const handleCancle = () => {
    setSelectedVehicleTypes([]);
    setSelectedVehicleTypesWithCategories({});
  };
  const Submit = () => {
    CreateVehicleCategory({
      variables: {
        createInput: { Vehicle_Category_Management: TempselectedVehicleTypes },
        AccountId: allFieldsData?._id,
      },
    })
      .then((res) => {
        setSelectedVehicleTypes(TempselectedVehicleTypes);
        setSelectedVehicleTypesWithCategories(tempCategory);
        setMultiselectModal(false);
        SuccessToast("Vehicle Category Created For this Account..!");
      })
      .catch((err) => ErrorToast(err.message));
  };
  return (
    <Reactportal
      open={open}
      onClose={Closeformfunction2}
      TypeOfPortal={"User Preference"}
      TypeOfId={"Load Id :"}
      UserRightsPortal=""
      id={""}
    >
      <div className="maincontainercityes">
        <div className="firstcontainer1">
          <div>
            <p className="headings">Vehicle Type</p>
          </div>

          {/* <Button
            disabled=""
            children=""
            type=""
            text={"Select Vehicle Category"}
            action={() => setMultiselectModal(true)}
            name="modalbutton"
          /> */}
          {selectedVehicleTypesWithCategories &&
            Object.keys(selectedVehicleTypesWithCategories).map((key, i) => {
              return (
                <div>
                  <p>{key}:</p>
                  <p>
                    {selectedVehicleTypesWithCategories[key]?.map((el) => {
                      return (
                        <>
                          <span>{el.Search_Value || el.Name}</span>
                          <br />
                        </>
                      );
                    })}
                  </p>
                </div>
              );
            })}

          {openMultiSelect && (
            <MultiSelectionComponent
              storeSelectedData={handleVehicleTypeCheckboxChange}
              show={openMultiSelect}
              Closeformfunction={() => {
                setTempCategory(selectedVehicleTypesWithCategories);
                setTempSelectedVehicleTypes(selectedVehicleTypes);
                setMultiselectModal(false);
              }}
              selectedData={TempselectedVehicleTypes}
              handleCancle={handleCancle}
              firstLevelQuery={GET_VEHICLE_TYPE}
              secondLevelQuery={GET_VEHICLE_CATEGORY}
              submit={Submit}
            />
          )}
        </div>
      </div>
      <div className=" buttonContainer buttonContainerForCategory">
        <Button
          disabled=""
          children=""
          type=""
          text={"Edit Vehicle Category"}
          action={() => setMultiselectModal(true)}
          name="modalbutton"
        />
      </div>
      <PortalFooter
        renderContent={() => (
          <>
            {/* <Button
              disabled=""
              children=""
              type=""
              text={"Edit"}
              action={() => setMultiselectModal(true)}
              name="modalbutton"
            /> */}
          </>
        )}
        disabled={false}
        submitform={""}
        submitType={""}
        SaveAndClose={""}
        handleformclose={() => {
          Closeformfunction2();
          setOpen(false);
        }}
        Cancletype={""}
        Delete={""}
        handleFileDelete={""}
        UserRightsPortal={""}
        TypeOfPortal={""}
        disableupload={""}
        name={""}
        loadingState={""}
      />
    </Reactportal>
  );
};
export default VehicleCategorySelection;
